/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AccessConfigDto { 
    globalRoles: Array<string>;
    /**
     * this is an array like [string, string[]][]
     */
    accessRoles: Array<string>;
    targetGroups?: Array<string>;
}

